import React from "react"
import "./style.css"
import MainAreaSection from "../MainAreaSection"
import useLang from "../../hooks/useLang"

const ProductsMainArea = ({ description, bannerPath, productImage }) => {
  const productsTitle = useLang() === "ar" ? "منتجاتنا" : "Products"
  const safePathBanned = bannerPath || ""

  const finalPath = safePathBanned
    ? `${productsTitle}/${safePathBanned}`
    : productsTitle

  const bannerImg = productImage
    ? productImage
    : require("../../images/product-banner-hero-5.png")

  return (
    <MainAreaSection
      img={bannerImg}
      title={""}
      currentPage={finalPath}
    >
      <div className="heading-text"></div>
    </MainAreaSection>
  )
}

export default ProductsMainArea

ProductsMainArea.defaultProps = {
  description: "Take a look at few of the Featured products we have worked on.",
  productImage: null,
}
